import { Suspense, lazy } from 'react';
import type { SlotEntry } from '@saas/ui';
import { STORAGE_READ } from './nav.js';

/**
 * 画面の差し込み口（`@saas/ui` の `Slot`）に storage が出すもの。登録は apps/web（リード）が行う
 * （`apps/web/src/app/slots.ts` の `entries` に `...storageSlots` を足す）。
 *
 * 部品は `lazy` + `Suspense`（初期バンドルを太らせない）。中身が空なら null を返して場所を取らない。
 */
const ProjectDocumentsDrawer = lazy(() => import('./components/ProjectDocumentsDrawer.js'));
const LinkedFilesPanel = lazy(() => import('./components/LinkedFilesPanel.js'));

export const storageSlots: SlotEntry[] = [
  {
    id: 'storage.projectDocuments',
    module: 'storage',
    slot: 'record.actions',
    subjectTypes: ['project'],
    permission: [STORAGE_READ],
    order: 40,
    Component: (props) => <Suspense fallback={null}><ProjectDocumentsDrawer {...props} /></Suspense>,
  },
  {
    id: 'storage.linkedFiles',
    module: 'storage',
    slot: 'record.panel',
    // lead（見込み客）は 2026-10-03 追加。見込み客を読めない人にはサーバが何も返さない（crm の判定器 `lead`）
    subjectTypes: ['customer', 'deal', 'contract', 'lead'],
    permission: [STORAGE_READ],
    order: 40,
    Component: (props) => (
      <Suspense fallback={null}>
        <LinkedFilesPanel {...props} />
      </Suspense>
    ),
  },
];
